import { useTranslate } from 'react-polyglot'
import { BlockOutlinedIcon } from '@getgo/chameleon-icons/react'
import { EmptyState } from '@getgo/chameleon-web-react-wrapper'
import { LinearProgress } from '@material-ui/core'
import type { SubAppModuleFederation } from '@ucc/admin-module-federation-utils'
import { ModuleFederationAppLoader } from '@ucc/admin-module-federation-utils'

import SetupSentry from 'components/routes/SetupSentry'
import { branchNameSubdomain } from 'config/featureBranch'

type ModuleFederationLoaderProps<T = { [key: string]: unknown }> = {
  module: string
  subAppModuleFederation: SubAppModuleFederation
  initSentry?: boolean
  key?: string
} & T
const ModuleFederationLoader = ({
  module,
  subAppModuleFederation,
  initSentry = true,
  ...otherProps
}: ModuleFederationLoaderProps): JSX.Element => {
  const t = useTranslate()
  return (
    <>
      {initSentry && <SetupSentry appName={subAppModuleFederation.appName} />}
      <ModuleFederationAppLoader
        module={module}
        fallbackComponent={<LinearProgress />}
        branchNameSubdomain={branchNameSubdomain}
        errorBoundaryFallbackComponent={
          <div style={{ display: 'flex' }}>
            <EmptyState title={t('Error')} icon={<BlockOutlinedIcon />}>
              {t('Unreachable content')}
            </EmptyState>
          </div>
        }
        {...subAppModuleFederation}
        {...otherProps}
      />
    </>
  )
}

export default ModuleFederationLoader
